import React, { useState, useEffect } from "react";
import CryptoJS from "crypto-js";
import ReactGA from "react-ga4";

function ItensComprados({ produtos, pagamento }) {
  const [imagensDescriptografadas, setImagensDescriptografadas] = useState([]);

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "Baixando imagens compradas",
    });
  }, []);

  useEffect(() => {
    if (!produtos || !pagamento) return;

    const imagens = produtos.map((produto) =>
      pagamento === "Pago"
        ? descriptografarImagem(produto.image)
        : produto.imageSample
    );

    setImagensDescriptografadas(imagens);
  }, [produtos, pagamento]);

  const descriptografarImagem = (imagemCriptografada) => {
    try {
      const bytes = CryptoJS.AES.decrypt(
        imagemCriptografada,
        import.meta.env.VITE_REACT_APP_BACKEND_JWT_SECRET // Certifique-se que esta variável está configurada corretamente no seu ambiente
      );

      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Erro ao descriptografar imagem:", error);
      return ""; // Tratamento de erro, retorne o que for apropriado para seu caso
    }
  };

  const baixarImagem = (urlImagem) => {
    window.open(urlImagem, "_blank");
  };

  if (!produtos || !pagamento) {
    return (
      <>
        <p>Carregando itens comprados... </p>{" "}
        <p>Caso demore muito, atualize a página.</p>
      </>
    );
  }

  return (
    <div className="px-4 py-8 max-w-7xl mx-auto">
      <div className="overflow-x-auto">
        <h2 className="text-xl text-center mb-4">Itens Comprados</h2>

        <table className="table">
          <tbody>
            {produtos.map((produto, index) => (
              <tr key={produto._id} className="bg-base-100 hover:bg-base-300">
                <td>
                  <div className="avatar w-40 h-28 ">
                    <img
                      src={
                        pagamento === "Pago"
                          ? imagensDescriptografadas[index]
                          : produto.imageSample
                      }
                      alt={produto.nome}
                    />
                  </div>
                </td>
                <td className="align-middle">
                  <button
                    className={`bg-blue-500 text-white p-2 rounded  ${
                      pagamento !== "Pago"
                        ? "opacity-50 cursor-not-allowed"
                        : ""
                    }`}
                    onClick={() =>
                      pagamento === "Pago" &&
                      baixarImagem(imagensDescriptografadas[index])
                    }
                    disabled={pagamento !== "Pago"}
                  >
                    Download
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ItensComprados;
